export default function AuditUnitFormData({ auditData, user }) {
  return new Promise((resolve) => {
    const formdata = new FormData()

    const condition = String(auditData.condition)
    formdata.append('audit_unit[letter]', condition)
    formdata.append('audit_unit[number]', condition)
    formdata.append('audit_unit[seen]', [1,2,3].includes(Number(condition)) ? '1' : '2')
    formdata.append('audit_unit[audited]', '1')
    formdata.append('audit_unit[can_refloor]', auditData.can_refloor)
    formdata.append('audit_unit[current_sold]', auditData.current_sold)
    formdata.append('audit_unit[current_date_sold]', auditData.current_date_sold)

    if (auditData.images && typeof auditData.images === 'object') {
      Object.entries(auditData.images).forEach(([imageTitle, imageFile]) => {
        if (imageFile) {  // Only append if file exists
          formdata.append(`audit_unit[unit_files][]name`, imageTitle)
          formdata.append(`audit_unit[unit_files][]ufile`, imageFile)
          formdata.append(`audit_unit[unit_files][]photo`, '1')
          formdata.append(`audit_unit[unit_files][]created_by_id`, String(user.id))
        }
      })
    }

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        formdata.append('audit_unit[lat]', position.coords.latitude)
        formdata.append('audit_unit[long]', position.coords.longitude)
        resolve(formdata)
      }, (error) => {
        console.error('Error getting geolocation:', error)
        resolve(formdata)
      })
    } else {
      resolve(formdata)
    }
  })
}